import SectionContainer from 'stories/V1/layouts/SectionContainer'
import QRCode from 'assets/homepage-redesign/qr-code.webp'
import styled from 'styled-components'
import _useTranslation from 'lib/hooks/_useTranslation'
import theme from 'stories/utils/theme'
import AppleLogo from 'assets/homepage-redesign/assets/homepage_apple.svg'
import GoogleLogo from 'assets/homepage-redesign/assets/homepage_google.svg'
import { Body2 } from 'stories/elements/Typography/Text'
import { redirectToAppDownloadUrlAsync } from 'lib/features/app-links'
import { AnalyticsEventHomepageDownloadQRClick } from 'lib/constants/AnalyticsEventType'
import { trackEvent } from 'lib/tracking/analytics-service'

const DownloadContainer = styled.div`
    section {
        @media (max-width: 740px) {
            padding: 40px 0 17.5px;
        }
    }
`

const ButtonsContainer = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
    width: 100vw;
    @media (max-width: 740px) {
        display: grid;
        width: 100vw;
        padding: 0 20px;
        grid-template-columns: 1fr 1fr;
    }
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    padding: 20px 0;
    @media (max-width: 740px) {
        gap: 20px;
        padding: 0;
    }
`

const QRImage = styled.img`
    @media (max-width: 860px) {
        display: none;
    }
`

const StoreButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background-color: ${theme.colors.white};
    border-radius: 52px;
    width: 160px;
    height: 52px;
    padding: 4px 8px;
    text-decoration: none;
    cursor: pointer;
    @media (max-width: 740px) {
        width: 100%;
    }
`

const ButtonContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1px;
`

const StoreLabel = styled(Body2)`
    font-family: var(--font-inter);
    font-size: 10px;
    line-height: 12px;
    font-weight: 500 !important;
    color: rgba(0, 0, 0, 0.6);
`

const StoreName = styled(Body2)`
    font-size: 17.5px;
    line-height: 20px;
    font-weight: 700;
    font-family: var(--font-inter);
    color: ${theme.colors.headlineDark};
    font-variation-settings: 'opsz' 32;
    white-space: nowrap;
`

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
`

const DownloadQRElement = () => {
    const { t } = _useTranslation('homepage')
    const { t: commonT } = _useTranslation('common')

    return (
        <DownloadContainer id="download-qr" style={{ scrollMarginTop: '10vh' }}>
            <SectionContainer
                title={t('homepage/downloadAppTitle')}
                borderRadius="48px"
                backgroundColor="radial-gradient(52.34% 100% at 50% 0%, #3f51b5 0%, #14183a 100%);"
                mobileBorderRadius="32px"
            >
                <Container>
                    <QRImage src={QRCode.src} alt="QR Code" width={220} height={220} />
                    <ButtonsContainer>
                        <StoreButton
                            onClick={() => {
                                trackEvent(AnalyticsEventHomepageDownloadQRClick, {
                                    referrerScreen: 'homepage',
                                    value: 'ios',
                                })
                                redirectToAppDownloadUrlAsync('ios', 'download-qr')
                            }}
                        >
                            <IconWrapper>
                                <AppleLogo />
                            </IconWrapper>
                            <ButtonContent>
                                <StoreLabel>{commonT('common/downloadInNativeLabelGoogle')}</StoreLabel>
                                <StoreName>App Store</StoreName>
                            </ButtonContent>
                        </StoreButton>
                        <StoreButton
                            onClick={() => {
                                trackEvent(AnalyticsEventHomepageDownloadQRClick, {
                                    referrerScreen: 'homepage',
                                    value: 'ios',
                                })
                                redirectToAppDownloadUrlAsync('android', 'download-qr')
                            }}
                        >
                            <IconWrapper>
                                <GoogleLogo />
                            </IconWrapper>
                            <ButtonContent>
                                <StoreLabel>{commonT('common/downloadInNativeLabelGoogle')}</StoreLabel>
                                <StoreName>Google Play</StoreName>
                            </ButtonContent>
                        </StoreButton>
                    </ButtonsContainer>
                </Container>
            </SectionContainer>
        </DownloadContainer>
    )
}

export default DownloadQRElement
